import { Button, DialogHeader, DialogBody, DialogFooter } from "@material-tailwind/react";
import { Modal } from "./Modal";
import { t } from "i18next";

export const NewVersionModal = ({ isLocalPlaying, onReload, ...props }) => (
  <Modal {...props}>{({ handleConfirm, handleCancel }) => {
    const handleReload = () => {
      if (onReload) {
        onReload();
      } else {
        window.location.reload();
      }
    };

    return (
      <>
        <DialogHeader>
          <div className="font-bebasneue text-3xl sm:text-4xl underline underline-offset-4 tracking-wide">
            {t('dialogs.new_version.title')}
          </div>
        </DialogHeader>
        <DialogBody>
          <div className="text-base text-gray-800 font-minion mb-4 leading-relaxed">
            {t('dialogs.new_version.message')}
          </div>
          {isLocalPlaying && (
            <div className="p-3.5 bg-yellow/20 border-l-4 border-yellow text-sm text-gray-900 rounded font-minion">
              <span className="font-bold mr-1">⚠️</span>
              {t('dialogs.new_version.warning_local_playback')}
            </div>
          )}
        </DialogBody>
        <DialogFooter>
          <Button variant="outlined" color="gray" onClick={handleCancel} className="mr-2 font-minion text-sm">
            <span>{t('dialogs.new_version.later')}</span>
          </Button>
          <Button variant="filled" color="yellow" onClick={handleReload} className="font-minion text-sm">
            <span>{t('dialogs.new_version.reload')}</span>
          </Button>
        </DialogFooter>
      </>
    );
  }}</Modal>
);
